/* KvS Header: megamenu's, voorspellend zoeken, mobiele lade, aftellen van de actie en wegschuiven bij scrollen.
   Hoort bij sections/kvs-header, kvs-header-mobile en kvs-search-results. Geen afhankelijkheden.
   De winkelwagen (data-drawer-options / data-cart-count) wordt door het thema zelf bediend. */
(function () {
  'use strict';
  var root = document.documentElement;
  var kh, scrim, drawer, openId = null, openedAt = 0, tOpen, tClose, tSearch, srOpen = false, drOpen = false;
  var cache = {}, ctrl = null, activeInput = null, campTimer = null;

  function $(sel, el) { return (el || document).querySelector(sel); }
  function $$(sel, el) { return Array.prototype.slice.call((el || document).querySelectorAll(sel)); }
  function syncScrim() {
    if (scrim) scrim.classList.toggle('is-on', !!openId || srOpen);
    var ov = $('[data-kh-dr-ov]');
    if (ov) ov.classList.toggle('is-on', drOpen);
  }

  /* ---------- Megamenu ---------- */
  function setOpen(id) {
    if (id === openId) return;
    openId = id;
    openedAt = Date.now();
    $$('[data-kh-panel]', kh).forEach(function (p) { p.classList.toggle('is-open', p.getAttribute('data-kh-panel') === id); });
    $$('[data-kh-open]', kh).forEach(function (b) { b.setAttribute('aria-expanded', String(b.getAttribute('data-kh-open') === id)); });
    if (id) closeSearch();
    syncScrim();
  }
  function bindMenu() {
    $$('[data-kh-open]', kh).forEach(function (b) {
      var id = b.getAttribute('data-kh-open');
      b.addEventListener('mouseenter', function () {
        clearTimeout(tClose); clearTimeout(tOpen);
        tOpen = setTimeout(function () { setOpen(id); }, openId ? 0 : 90);
      });
      b.addEventListener('click', function (e) {
        clearTimeout(tOpen);
        if (openId === id) {
          /* Net geopend door hover: niet meteen weer dicht. Daarna gaat een link gewoon naar zijn pagina. */
          if (Date.now() - openedAt < 450) { e.preventDefault(); return; }
          if (b.tagName === 'A') return;
          setOpen(null);
          return;
        }
        e.preventDefault();
        setOpen(id);
      });
    });
    var hoverZones = [$('.kh-nav', kh)].concat($$('[data-kh-panel]', kh));
    hoverZones.forEach(function (el) {
      if (!el) return;
      el.addEventListener('mouseleave', function () { clearTimeout(tOpen); tClose = setTimeout(function () { setOpen(null); }, 180); });
      el.addEventListener('mouseenter', function () { clearTimeout(tClose); });
    });
    var camp = $('.kh-nav__camp', kh);
    if (camp) camp.addEventListener('mouseenter', function () { clearTimeout(tOpen); setOpen(null); });
  }

  /* ---------- Zoeken ---------- */
  function srp() { return $('[data-kh-srp]', kh); }
  function tpl(name) { var t = $('[data-kh-tpl="' + name + '"]', kh); return t ? t.innerHTML : ''; }
  function openSearch() {
    if (srOpen) return;
    srOpen = true;
    setOpen(null);
    srp().hidden = false;
    var cb = $('[data-kh-srclose]', kh); if (cb) cb.hidden = false;
    syncScrim();
  }
  function closeSearch() {
    if (!srOpen) return;
    srOpen = false;
    srp().hidden = true;
    var cb = $('[data-kh-srclose]', kh); if (cb) cb.hidden = true;
    $$('.kh-search.is-wide', kh).forEach(function (f) { f.classList.remove('is-wide'); });
    syncScrim();
  }
  function paint(q, html) {
    if (!activeInput || activeInput.value.trim() !== q) return;
    var box = srp();
    if (!html || html.indexOf('data-kh-none') > -1) {
      box.innerHTML = tpl('none');
      var term = $('[data-kh-term]', box);
      if (term) term.textContent = q;
    } else {
      box.innerHTML = html;
    }
  }
  /* Zoeksynoniemen uit de instelling (woord=zoekt op), per heel woord */
  function syn(q) {
    var list = (srp().getAttribute('data-syn') || '').split(/\n/);
    list.forEach(function (row) {
      var kv = row.split('=');
      if (kv.length < 2 || !kv[0].trim()) return;
      var w = kv[0].trim().replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      q = q.replace(new RegExp('(^|\\s)' + w + '(?=\\s|$)', 'gi'), '$1' + kv.slice(1).join('=').trim());
    });
    return q;
  }
  function search(raw) {
    var q = (raw || '').trim();
    clearTimeout(tSearch);
    if (!q) { srp().innerHTML = tpl('start'); return; }
    if (cache[q] !== undefined) { paint(q, cache[q]); return; }
    tSearch = setTimeout(function () {
      if (ctrl) ctrl.abort();
      ctrl = 'AbortController' in window ? new AbortController() : null;
      var opts = ctrl ? { signal: ctrl.signal } : {};
      var get = function (term) {
        var url = srp().getAttribute('data-url') + '?q=' + encodeURIComponent(term) +
          '&resources[type]=product,collection,query&resources[limit]=10&resources[limit_scope]=each&section_id=kvs-search-results';
        return fetch(url, opts)
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (text) { return new DOMParser().parseFromString(text, 'text/html').getElementById('shopify-section-kvs-search-results'); });
      };
      /* Met een synoniem: producten van het synoniem, categorieën en voettekst bij wat de klant typte */
      var q2 = syn(q);
      Promise.all([get(q2), q2 !== q ? get(q) : null])
        .then(function (res) {
          var sec = res[0], orig = res[1];
          if (sec && orig) {
            var side = sec.querySelector('.kh-srp__side'), oside = orig.querySelector('.kh-srp__side');
            if (side && oside && oside.children.length) side.innerHTML = oside.innerHTML;
            var foot = sec.querySelector('.kh-srp__foot span');
            if (foot) foot.textContent = 'Resultaten voor "' + q + '"';
          }
          cache[q] = sec ? sec.innerHTML.trim() : '';
          paint(q, cache[q]);
        })
        .catch(function () {});
    }, 160);
  }
  function bindSearch() {
    $$('[data-kh-search]', kh).forEach(function (form) {
      var inp = $('input[name="q"]', form);
      var box = $('.kh-search__box', form);
      inp.addEventListener('focus', function () {
        activeInput = inp;
        /* Eindbreedte van het opengeklapte veld (1100-1279): van rechts tot vlak naast het logo */
        var logo = $('.kh-logo', kh);
        if (logo) form.style.setProperty('--kh-sw', Math.max(260, Math.round(form.getBoundingClientRect().right - logo.getBoundingClientRect().right - 28)) + 'px');
        form.classList.add('is-wide');
        search(inp.value);
        openSearch();
      });
      inp.addEventListener('input', function () {
        form.classList.toggle('has-q', !!inp.value);
        search(inp.value);
        openSearch();
      });
      $('[data-kh-clear]', form).addEventListener('click', function () {
        inp.value = '';
        form.classList.remove('has-q');
        search('');
        inp.focus();
      });
      form.addEventListener('submit', function (e) { if (!inp.value.trim()) { e.preventDefault(); return; } inp.value = syn(inp.value.trim()); });
      /* Klik op het vergrootglas of de rand zet de focus in het veld (1100-1279 is het veld ingeklapt) */
      box.addEventListener('mousedown', function (e) { if (e.target !== inp) { e.preventDefault(); inp.focus(); } });
    });
    srp().addEventListener('click', function (e) {
      var f = e.target.closest('[data-kh-fill]');
      if (!f || !activeInput) return;
      e.preventDefault();
      activeInput.value = f.getAttribute('data-kh-fill');
      activeInput.closest('form').classList.add('has-q');
      search(activeInput.value);
      activeInput.focus();
    });
  }

  /* ---------- Mobiele lade ---------- */
  function drGo(lvl, back) {
    $$('[data-kh-lvl]', drawer).forEach(function (l) {
      var on = l.getAttribute('data-kh-lvl') === lvl;
      l.classList.toggle('is-on', on);
      l.classList.remove('is-in', 'is-back');
      if (on && back !== null) { void l.offsetWidth; l.classList.add(back ? 'is-back' : 'is-in'); }
    });
    var body = $('[data-kh-drbody]', drawer);
    if (body) body.scrollTop = 0;
  }
  function openDrawer() {
    if (!drawer) return;
    closeSearch();
    setOpen(null);
    drOpen = true;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    $('[data-kh-burger]', kh).setAttribute('aria-expanded', 'true');
    root.classList.add('kh-lock');
    syncScrim();
    setTimeout(function () { var x = $('[data-kh-close]', drawer); if (x) x.focus(); }, 60);
  }
  function closeDrawer() {
    if (!drawer || !drOpen) return;
    drOpen = false;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    $('[data-kh-burger]', kh).setAttribute('aria-expanded', 'false');
    root.classList.remove('kh-lock');
    syncScrim();
    setTimeout(function () { if (!drOpen) drGo('top', null); }, 520);
  }
  function bindDrawer() {
    drawer = $('[data-kh-drawer]');
    var burger = $('[data-kh-burger]', kh);
    if (burger) burger.addEventListener('click', openDrawer);
    if (!drawer) return;
    var ov = $('[data-kh-dr-ov]');
    if (ov) ov.addEventListener('click', closeDrawer);
    drawer.addEventListener('click', function (e) {
      var t = e.target;
      var go = t.closest('[data-kh-go]');
      if (go) { drGo(go.getAttribute('data-kh-go'), false); return; }
      if (t.closest('[data-kh-back]')) { drGo('top', true); return; }
      if (t.closest('[data-kh-close]')) { closeDrawer(); return; }
      if (t.closest('[data-kh-search-open]')) {
        closeDrawer();
        setTimeout(function () { var q = document.getElementById('kh-qm'); if (q) q.focus(); }, 320);
      }
    });
  }

  /* ---------- Actie in de aankondigingsbalk ---------- */
  function bindCampaign() {
    clearInterval(campTimer);
    var top = $('[data-kh-top]', kh);
    if (!top || !top.hasAttribute('data-start')) return;
    var start = +top.getAttribute('data-start') || 0, end = +top.getAttribute('data-end') || 0;
    var teaser = top.getAttribute('data-teaser') === 'true';
    var cnt = $('[data-kh-count]', top), navCamp = $('[data-kh-camp-nav]', kh), drCamp = $('[data-kh-dr-camp]');
    var navLink = navCamp && $('a', navCamp);
    if (drCamp && navLink) { drCamp.href = navLink.href; $('span', drCamp).textContent = navLink.textContent; }
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var now = Date.now();
      var state = end && now >= end ? 'over' : start && now < start ? 'before' : 'live';
      top.classList.toggle('is-camp', state === 'live' || (state === 'before' && teaser));
      if (navCamp) navCamp.hidden = state !== 'live';
      if (drCamp) drCamp.hidden = state !== 'live' || !navLink;
      if (cnt) {
        var d = Math.max(0, (state === 'before' ? start : end) - now);
        cnt.textContent = cnt.getAttribute(state === 'before' ? 'data-before' : 'data-during') + ' ' +
          Math.floor(d / 864e5) + 'd ' + pad(Math.floor(d / 36e5) % 24) + 'u ' + pad(Math.floor(d / 6e4) % 60) + 'm';
      }
    }
    tick();
    campTimer = setInterval(tick, 30000);
  }

  /* ---------- Opstarten (en opnieuw na een wijziging in de theme editor) ---------- */
  function init() {
    kh = $('[data-kh]');
    if (!kh) return;
    scrim = $('[data-kh-scrim]');
    openId = null; srOpen = false; drOpen = false;
    bindMenu();
    bindSearch();
    bindDrawer();
    bindCampaign();
    if (typeof setOffset === 'function') setOffset();
    if (scrim) scrim.addEventListener('click', function () { setOpen(null); closeSearch(); closeDrawer(); });
  }
  init();

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var btn = openId && $('[data-kh-open="' + openId + '"]', kh);
    setOpen(null);
    closeSearch();
    closeDrawer();
    if (btn) btn.focus();
  });
  document.addEventListener('click', function (e) {
    if (!kh) return;
    if (srOpen && !e.target.closest('[data-kh-search]') && !e.target.closest('[data-kh-srp]')) closeSearch();
    if (openId && !e.target.closest('.kh-bar')) setOpen(null);
  });
  document.addEventListener('focusin', function (e) {
    if (openId && !e.target.closest('.kh-nav') && !e.target.closest('[data-kh-panel]')) setOpen(null);
  });

  /* Zichtbare hoogte van de header als --kh-offset (0 als hij weg is), zodat plakkende onderdelen
     elders (galerij, filters, FAQ) eronder blijven. --kvs-sticky-top is dezelfde waarde voor kvs-collection. */
  function setOffset() {
    if (!kh) return;
    var h = 0;
    if (!kh.classList.contains('is-hidden')) {
      var bar = $('.kh-bar', kh), ms = $('.kh-msearch', kh);
      h = (bar ? bar.offsetHeight : 0) + (ms && ms.offsetHeight && !kh.classList.contains('is-compact') ? ms.offsetHeight : 0);
    }
    root.style.setProperty('--kh-offset', h + 'px');
    root.style.setProperty('--kvs-sticky-top', h + 'px');
  }
  setOffset();
  window.addEventListener('resize', setOffset);

  /* Wegschuiven bij omlaag scrollen, terug bij omhoog. De aankondigingsbalk scrolt gewoon mee weg (CSS).
     Mobiel: bij het wegschuiven wordt de kop compact (zoekbalk dicht, vergrootglas in de balk), zodat hij bij
     omhoog scrollen minder ruimte inneemt. Bovenaan de pagina staat de zoekbalk weer open. */
  var lastY = window.pageYOffset, holdUntil = 0;
  window.addEventListener('scroll', function () {
    if (!kh) return;
    var y = window.pageYOffset, was = kh.classList.contains('is-hidden'), wasC = kh.classList.contains('is-compact');
    if (openId || srOpen || drOpen || Date.now() < holdUntil) { lastY = y; return; }
    if (y > 260 && y > lastY + 4) { kh.classList.add('is-hidden'); kh.classList.add('is-compact'); }
    else if (y < lastY - 4 || y < 120) kh.classList.remove('is-hidden');
    if (y < 120) kh.classList.remove('is-compact');
    if (was !== kh.classList.contains('is-hidden') || wasC !== kh.classList.contains('is-compact')) setOffset();
    lastY = y;
  }, { passive: true });
  /* Sluitknop onderin (mobiel): paneel dicht en toetsenbord weg */
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-kh-srclose]') || !kh) return;
    if (activeInput) activeInput.blur();
    closeSearch();
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-kh-msbtn]'); if (!b || !kh) return;
    /* Het uitklappen verschuift de pagina; die verschuiving niet als omlaag scrollen zien */
    holdUntil = Date.now() + 600;
    kh.classList.remove('is-compact', 'is-hidden');
    setOffset();
    var inp = $('.kh-msearch input[name="q"]', kh); if (inp) inp.focus({ preventScroll: true });
  });

  /* Theme editor: bij laden opnieuw opstarten, bij een geselecteerd blok het juiste paneel of de lade openen */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('[data-kh]') || e.target.querySelector('[data-kh-drawer]')) init();
  });
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target;
    var panel = el.closest('[data-kh-panel]');
    var item = el.closest('[data-kh-open]');
    if (panel || item) { setOpen((panel || item).getAttribute(panel ? 'data-kh-panel' : 'data-kh-open')); return; }
    if (drawer && drawer.contains(el)) {
      openDrawer();
      var lvl = el.closest('[data-kh-lvl]');
      var go = el.getAttribute('data-kh-go');
      drGo(go || (lvl ? lvl.getAttribute('data-kh-lvl') : 'top'), null);
    }
  });
  document.addEventListener('shopify:block:deselect', function () { setOpen(null); });
})();
